import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ConsultaService } from "src/app/services/http/consulta.service";
import { HistoricoConsultaService } from "src/app/services/http/historico-consulta.service";
import { UnidadeService } from "src/app/services/http/unidade.service";
import { ConsultaHistorico } from "src/app/models/consulta-historico";
import { FormControl } from "@angular/forms";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { Observable, forkJoin } from "rxjs";
import { Consulta } from "src/app/models/consulta";
import { LoginService } from "src/app/services/login.service";
import { Unidade } from "src/app/models/Unidade";
import { CiacService } from "src/app/services/http/ciac.service";
import { ChaveEntrada } from "src/app/models/chave-entrada";
import { ConsultaInsumo } from "src/app/models/consulta-insumo";
import { DateUtil } from "src/app/utils/date.util";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-list-historico-consulta",
  templateUrl: "./list-historico-consulta.component.html",
  styleUrls: ["./list-historico-consulta.component.scss"],
})
export class ListHistoricoConsultaComponent implements OnInit {
  dynamicdownloadName = "Lista_Historico_Consulta";
  pesquisaChave = new FormControl();
  pesquisaId = new FormControl();
  pesquisaUsuario = new FormControl();
  pesquisaStatus = new FormControl();
  pesquisaDataInicio: any;
  pesquisaDataFim: any;
  exibirHistoricoGeral: boolean;
  listaConsultas: ConsultaHistorico[] = [];
  total = 0;
  tableLoading = true;
  //login: '';
  dataPassada: any;
  urlPdf;
  listaStatus = [
    { codigo: null, nome: "TODOS" },
    { codigo: 0, nome: "SUCESSO" },
    { codigo: 100, nome: "ERRO" },
  ];

  filter = {
    page: 1,
    per_page: 10,
    filter: {
      id: "",
      nome: "",
      usuarioNome: "",
      usuario: { nome: "" },
      sorting: { dataCriacao: "asc" },
      entrada: "",
      listaStatus: null,
      dataInicio: new Date(),
      dataFim: new Date(),
      unidade: null,
      exibirHistoricoGeral: null,
      listaConsultaSelecionada: <any>[],
      order: {
        idConsultaVeiculo: "",
        dataCriacao: "desc",
        status: "",
        razaosocial: "",
        nomeUsuario: "",
      },
    },
  };

  listaTipoConsulta: any[];
  pesquisaConsulta: any;
  consultaSelecionada: any[];
  inputConsultaFormat = (c) => c.nomeConsulta;

  listaUnidades: any[];
  pesquisaCliente: any;
  unidadeSelecionada: any;
  inputClienteFormat = (c: Unidade) => c.nomeFantasia;

  first: number = 0;
  consulta: any = {};

  cols: any = [
    { field: "id", header: "Id" },
    { field: "usuario.nome", header: "Usuário" },
    { field: "listaChaveEntradaPrint", header: "Chave de Consulta" },
    { field: "listaInsumoPrint", header: "Consulta" },
    { field: "dataConsultaPrint", header: "Data" },
  ];

  cols2: any = [
    { field: "id", header: "Id" },
    { field: "unidade.nomeFantasia", header: "Cliente" },
    { field: "usuario.nome", header: "Usuário" },
    { field: "listaChaveEntradaPrint", header: "Chave de Consulta" },
    { field: "listaInsumoPrint", header: "Consulta" },
    { field: "dataConsultaPrint", header: "Data" },
  ];

  exibeBotaoMaluco: boolean;

  constructor(
    public router: Router,
    public activeRoute: ActivatedRoute,
    private consultaService: ConsultaService,
    private historicoService: HistoricoConsultaService,
    private loginService: LoginService,
    private unidadeService: UnidadeService,
    private ciacService: CiacService
  ) { }

  ngOnInit() {
    this.exibeBotaoMaluco = false;
    this.filter.filter.dataInicio.setDate(1);
    this.exibirHistoricoGeral = this.activeRoute.snapshot.data["geral"];
    this.filter.filter.exibirHistoricoGeral = this.exibirHistoricoGeral;

    //igualar intervalo para reduzir esforço inicial
    this.filter.filter.dataInicio = this.filter.filter.dataFim;
    this.filter.filter.dataInicio.setHours(0, 0, 0, 0);
    //fim

    const urlParams = this.activeRoute.snapshot.queryParams;

    if (urlParams.entrada) {
      this.filter.filter.entrada = urlParams.entrada;
      this.pesquisaChave.setValue(urlParams.entrada);
    }

    let avulsas = urlParams.consultas ? urlParams.consultas.split(",") : [];
    let combinadas = urlParams.combinadas
      ? urlParams.combinadas.split(",")
      : [];

    forkJoin([
      this.unidadeService
        .getListaUnidadeNomeFantasia()
        .then((c) => (this.listaUnidades = c)),
      this.consultaService.listaConsultaAvulsaCombinada().then((c) => {
        this.listaTipoConsulta = c;
        this.listaTipoConsulta
          .filter((tc) => tc.tipoConsulta == "AVULSA")
          .forEach((c) => (c.checked = avulsas.filter((cc) => cc == c.id) > 0));
        this.listaTipoConsulta
          .filter((tc) => tc.tipoConsulta == "COMBINADA")
          .forEach(
            (c) => (c.checked = combinadas.filter((cc) => cc == c.id) > 0)
          );
        this.filter.filter.listaConsultaSelecionada =
          this.listaTipoConsulta.filter((c) => c.checked);
      }),
    ])
      .toPromise()
      .then((v) => {
        this.ciacService.getListaConsultaCreditoSemInsumos().then((ci) => {
          ci.forEach((e) => {
            let data = {
              id: e.id,
              nomeConsulta: e.nome,
              tipoConsulta: "AVULSA",
              checked: e.checked ? e.checked : false,
            };
            this.listaTipoConsulta.push(data);
          });
        });
      })
      .then((r) => this.getHistorico());

    this.pesquisaChave.valueChanges
      .pipe(
        debounceTime(800) //espera 1 segundo e meio para chamar o subscribe apos cada entrada
      )
      .subscribe((value) => {
        this.filter.filter.entrada = value;
      });

    this.pesquisaId.valueChanges
      .pipe(
        debounceTime(800) //espera 1 segundo e meio para chamar o subscribe apos cada entrada
      )
      .subscribe((value) => {
        this.filter.filter.id = value;
      });

    this.pesquisaUsuario.valueChanges
      .pipe(
        debounceTime(800) //espera 1 segundo e meio para chamar o subscribe apos cada entrada
      )
      .subscribe((value) => {
        this.filter.filter.usuario.nome = value;
        this.filter.filter.usuarioNome = value;
      });

    this.pesquisaStatus.valueChanges.pipe().subscribe((value) => {
      this.filter.filter.listaStatus = value;
    });

    this.pesquisaConsulta = (text: Observable<string>) =>
      text.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map((term) =>
          this.listaTipoConsulta
            .filter(
              (c) =>
                c.nomeConsulta.toLowerCase().indexOf(term.toLowerCase()) > -1 &&
                !c.checked
            )
            .slice(0, 10)
        )
      );

    if (this.exibirHistoricoGeral) {
      this.pesquisaCliente = (text: Observable<string>) =>
        text.pipe(
          debounceTime(200),
          distinctUntilChanged(),
          map((term) =>
            this.listaUnidades
              .filter(
                (c) =>
                  c.nomeFantasia.toLowerCase().indexOf(term.toLowerCase()) > -1
              )
              .slice(0, 10)
          )
        );
    }
  }

  removeEmpty(obj) {
    Object.keys(obj).forEach((key) => obj[key] == "" && delete obj[key]);
    return obj;
  }

  getHistoricoGeral() {
    // this.exibeBotaoMaluco = false;
    this.getHistorico();
    // this.aguardar(8000);
  }

  async getHistorico() {

    const param = {
      ...this.filter,
      filter: {
        ...this.filter.filter,
        sorting: this.removeEmpty({ ...this.filter.filter.order }),
        dataFim: this.filter.filter.dataFim.getTime(),
        dataInicio: this.filter.filter.dataInicio.getTime(),
      },
    };

    this.tableLoading = true;
    let r;
    r = await this.historicoService.getHistoricoCliente(param, ["loading"]);

    this.total = r.total;
    this.listaConsultas = r.lista;
    this.insertModePrint();

    this.tableLoading = false;

    this.aguardar(3000);
  }

  aguardar(milisegundos) {
    setTimeout(function () {
      var botoes = document.getElementById("btnM");
      botoes.click();
    }, milisegundos);
  }

  insertModePrint() {
    this.listaConsultas.map((consulta) => {
      var retornoChave = "";
      var retornoInsumo = "";
      consulta?.listaChaveEntrada?.map((chave, index) => {
        retornoChave = this.printChaveForCSV(
          chave,
          retornoChave,
          index,
          consulta
        );
      });
      consulta?.listaInsumo?.map((insumo, index) => {
        retornoInsumo = this.printInsumoForCSV(
          insumo,
          retornoInsumo,
          index,
          consulta
        );
      });
      consulta.listaChaveEntradaPrint = retornoChave;
      consulta.listaInsumoPrint = retornoInsumo;
      consulta.dataConsultaPrint = this.printDateForCSV(consulta.dataConsulta);
    });
  }

  private printChaveForCSV(
    chave: ChaveEntrada,
    retorno: string,
    index: number,
    consulta: ConsultaHistorico
  ) {
    if (chave.tipo == "PLACA") {
      retorno += this.printPlaca(chave.chaveEntrada);
    } else {
      if (chave.chaveEntrada) {
        retorno += chave.chaveEntrada;
      }
    }
    if (index < consulta.listaChaveEntrada.length - 1) {
      retorno += ", ";
    }
    return retorno;
  }

  private printInsumoForCSV(
    chave: ConsultaInsumo,
    retorno: string,
    index: number,
    consulta: ConsultaHistorico
  ) {
    retorno += chave?.nomeConsulta + " - " + chave?.codigoControle;
    if (index < consulta?.listaInsumo?.length - 1) {
      retorno += ", ";
    }
    return retorno;
  }

  private printDateForCSV(date: Date): string {
    return DateUtil.dateTypeFormatStr2(new Date(date));
  }

  printPlaca(value: string): string {
    let newValue: string = (value || "")
      .toString()
      .toUpperCase()
      .replace("-", "")
      .trim();
    let arrayValue = newValue.split("");
    if (arrayValue.length > 3) {
      arrayValue.splice(2, 1, arrayValue[2] + "-");
      newValue = arrayValue.join("");
    }
    return newValue;
  }

  setPageSize(pageSize) {
    this.filter.page = 1;
    this.filter.per_page = pageSize;
    this.getHistorico();
  }

  addFiltroConsulta(selected) {
    if (!selected.item.checked) {
      selected.item.checked = true;
      this.filter.filter.listaConsultaSelecionada =
        this.listaTipoConsulta.filter((c) => c.checked);
      this.getHistorico();
    }
    this.consultaSelecionada = [];
    selected.preventDefault();
  }

  removeFiltroConsulta(consulta: Consulta) {
    consulta.checked = false;
    this.filter.filter.listaConsultaSelecionada = this.listaTipoConsulta.filter(
      (c) => c.checked
    );
    this.getHistorico();
  }

  addFiltroUnidade(event: any) {
    var unidade = event.item;
    this.filter.filter.unidade = unidade.id;
  }

  removeFiltroUnidade() {
    this.filter.filter.unidade = null;
  }

  nextPage() {
    this.getHistorico();
  }


  printPdf(url: string) {
    // 1️⃣ Abre uma aba em branco imediatamente (sincronamente ao clique)
    const novaAba = window.open('', '_blank');
    // 2️⃣ Exibe uma mensagem temporária (HTML simples)
    if (novaAba) {
      novaAba.document.write(`
      <html>
        <head><title>Gerando Relatório...</title></head>
        <body style="font-family: sans-serif; padding: 2rem;">
          <h2>⏳ Gerando relatório PDF...</h2>
          <p>Isso pode levar até 2 minutos. A janela será atualizada automaticamente.</p>
        </body>
      </html>
    `);
    }
    this.consultaService.getRelatorioPdf(url).subscribe({
      next: (blob: Blob) => {
        const fileURL = window.URL.createObjectURL(blob);

        // 3️⃣ Se a aba foi aberta com sucesso, redireciona o conteúdo
        if (novaAba) {
          novaAba.location.href = fileURL;
        } else {
          // Fallback: se popup bloqueado mesmo assim
          window.open(fileURL, '_blank');
        }

      },
      error: (err) => {
        console.error('Erro ao baixar PDF:', err);
        if (novaAba) {
          novaAba.document.write('<h3>Erro ao gerar relatório.</h3>');
        }
      },
    });
  }

}
